import ProfileDetails from "./cards/components/ProfileDetails";
import { SignInMethod } from "./cards/components/SignInMethod";
import TwoFactorAuthDetails from "./cards/components/TwoFactorAuthDetails";

const AccountDetails: React.FC = () => {
  return (
    <div className="card">
      <div className="card-body px-0">
        <div className="row">
          <ProfileDetails />
        </div>
        <div className="separator separator-dashed"></div>
        <div className="row">
          <SignInMethod />
        </div>
        <div className="separator separator-dashed"></div>
        <div className="row">
          <TwoFactorAuthDetails />
        </div>
      </div>
    </div>
  );
};

export default AccountDetails;
